const { authorizedRequests } = require("../axios/axios-config");

const getSalesReport = async (data) => {
  const response = await authorizedRequests({
    url: "reports/newSalesReport",
    method: "post",
    data,
  });
  return response;
};

const getReferralReport = async (data) => {
  const response = await authorizedRequests({
    url: "reports/referralReport",
    method: "post",
    data,
  });
  return response;
};

const getSalesReportByStaff = async (data) => {
  const response = await authorizedRequests({
    url: "reports/salesReportStaff",
    method: "post",
    data,
  });
  return response;
};

const getTopSpenderReport = async (data) => {
  const response = await authorizedRequests({
    url: "reports/topSpenderReport",
    method: "post",
    data,
  });
  return response;
};

const getDrugMovementReport = async (data) => {
  const response = await authorizedRequests({
    url: "reports/drugMovementReport",
    method: "post",
    data,
  });
  return response;
};

const getUnconsumableReport = async (data) => {
  const response = await authorizedRequests({
    url: "reports/unconsumableReport",
    method: "post",
    data,
  });
  return response;
};
const getLowStockReport = async (data) => {
  const response = await authorizedRequests({
    url: "reports/lowStockReport",
    method: "post",
    data,
  });
  return response;
};

const getReceivingListingReport = async (data) => {
  const response = await authorizedRequests({
    url: "reports/receivingListingReport",
    method: "post",
    data,
  });
  return response;
};

const getPaymentReport = async (data) => {
  const response = await authorizedRequests({
    url: "reports/staff/finance/paymentMethod",
    method: "post",
    data,
  });
  return response;
};

const getRefundReport = async (data) => {
  const response = await authorizedRequests({
    url: "reports/staff/finance/refundReport",
    method: "post",
    data,
  });
  return response;
};

const getRevenueReport = async (data) => {
  const response = await authorizedRequests({
    url: "reports/staff/finance/revenueReport",
    method: "post",
    data,
  });
  return response;
};

const getDailyRevenueReport = async (data) => {
  const response = await authorizedRequests({
    url: "reports/staff/finance/dailyRevenueReport",
    method: "post",
    data,
  });
  return response;
};

const getIndividualTreatmentSalesReport = async (data) => {
  const response = await authorizedRequests({
    url: "reports/staff/finance/individualTreatmentSalesReport",
    method: "post",
    data,
  });
  return response;
};

const getDiscountReport = async (data) => {
  const response = await authorizedRequests({
    url: "reports/staff/finance/discountReport",
    method: "post",
    data,
  });
  return response;
};

const getPackageExpiryReport = async (data) => {
  const response = await authorizedRequests({
    url: "reports/packageExpiryReport",
    method: "post",
    data,
  });
  return response;
};

export {
  getSalesReport,
  getReferralReport,
  getSalesReportByStaff,
  getTopSpenderReport,
  getDrugMovementReport,
  getUnconsumableReport,
  getPackageExpiryReport,
  getPaymentReport,
  getRefundReport,
  getRevenueReport,
  getDailyRevenueReport,
  getDiscountReport,
  getIndividualTreatmentSalesReport,
  getLowStockReport,
  getReceivingListingReport,
};
